import { axiosJWTInstance } from "../../utils/axiosJWTInstance";
import { Dispatch } from "redux";
import {
  GET_ORIGINS_ATTEMPT,
  GET_ORIGINS_SUCCESS,
  GET_ORIGINS_FAILURE,
} from "../constants";

// getOrigins actions
const getOriginsAttempt = () => ({
  type: GET_ORIGINS_ATTEMPT,
});

const getOriginsSuccess = (payload: any) => ({
  type: GET_ORIGINS_SUCCESS,
  payload,
});

const getOriginsFailure = (error: string) => ({
  type: GET_ORIGINS_FAILURE,
  payload: {
    error,
  },
});

export const getOriginsRequest = (data: any, paramsToAdd?:any) => (dispatch: Dispatch) => {
  dispatch(getOriginsAttempt());

  const params2 = {
    entity: "origins",
    ...paramsToAdd
  }

  const searchParams = new URLSearchParams(params2);
  const webUrl = `/Orders?${searchParams.toString()}`;

  return axiosJWTInstance
    .post(webUrl, data, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "content-type": "application/json",
      }
    })
    .then((res) => res.data)
    .then((payload) => {
      dispatch(getOriginsSuccess(payload));
    })
    .catch((error) => {
      dispatch(getOriginsFailure(error.message));
    });
};
